(function ($) {
  'use strict';
  class CashBackGuide {
    
    static multiple = undefined;

    constructor() {
        this.store = __Xtool_Utils.getStore();
        this.cashBackGuide();
        this.productPageCashbackClass = 'product_page_cashback'
    }


   // 购物n倍反积分接口
    cashBackGuide() {
      try {
          const queryParams = new URLSearchParams({
            store: __Xtool_Utils.getStore(),
            customer_id: window.theme.customer_id || '',
          }).toString();
          var headers = __Xtool_Utils.getSignatureHeader()
          $.ajax({
              type: 'GET',
              url: `${__Xtool_Utils.getXccApiDomain()}/xtool-creators-club/v1/customers/point/task/purchase?${queryParams}`,
              contentType: 'application/json',
              headers,
              dataType: 'json',
          })
          .done((res) => {
            const { code, data } = res;
            if (code === 0) {
              let multiple = 1;
              let is_not_purchased_yet = true;
              let redeem_rate
              if (code !== 104213) {
                multiple = data.multiple;
                is_not_purchased_yet = data.is_not_purchased_yet;
                redeem_rate = data.redeem_rate;
              }
              CashBackGuide.multiple = multiple;
              $("mkt-point-cashback-guide").each((index, ele) => {
                  ele.setAttribute('multiple', multiple);
                  ele.setAttribute('is-not-purchased-yet', is_not_purchased_yet? 'true': 'false');
                  ele.setAttribute('redeem-rate', redeem_rate);
                  ele.style.display = 'block';
                  const cashbackIcon = $(ele).find('.product_page_cashback_icon');
                  if (cashbackIcon.length) {
                    cashbackIcon.removeClass('d-none-important');
                  }
                  this.updateCashbackGuide();
              });

              // 触发事件 (该逻辑是为了处理购物车的cashback)
              window.cashBackGuide = {
                multiple,
                isNotPurchasedYet: is_not_purchased_yet,
                redeemRate: redeem_rate
              }
              document.dispatchEvent(new CustomEvent('cashBackGuideLoaded', {
                detail: window.cashBackGuide
              }));
            } else if (code === 104213) {
              $("mkt-point-cashback-guide").addClass('d-none-important');
            }
          })
          .fail(function (jqXHR, status, error) {
              console.error('', error)
          });
        } catch(e) {
          console.error('获取用户积分失败', e)
        }

      $('.pf-variant-select').on('change', (e)=> {
          setTimeout(() => {
              const form = e.target.closest('form');
              const inputNode = $(form).find('input[name=id]');
              if (inputNode && inputNode[0]) {
                 const productId = +inputNode[0].dataset.productId;
                 const variantId = +inputNode[0].value;
                 const product = window.__pageflyProducts[productId];
                 const varaint = product.variants.find(variant => variant.id === variantId);
                 const cashbackNodes = $(form).find('mkt-point-cashback-guide');
                 if (cashbackNodes.length) {
                      $(cashbackNodes).each((index, ele) => {
                          $(ele).attr('price', varaint.price)
                      })
                 }
              }

          }, 300)
      })
  }

  updateCashbackGuide() {
    $(`mkt-point-cashback-guide.${this.productPageCashbackClass}`).each((index, ele) => {
      const finalPrice = this.getFinalPrice();
      if (finalPrice !== undefined) {
        ele.setAttribute('price', finalPrice);
      }
    })
  }

  // 获取到手价
  getFinalPrice() {
    const productPagePriceContainer = $('.product-page-info-price-container');
    const finalPriceContainer = productPagePriceContainer.find('.estimated-final-price');
    if (finalPriceContainer.css('display') !== 'none') {
      const $finalPriceEle = productPagePriceContainer.find(`[data-estimated-price]`);
      if ($finalPriceEle.length) {
        return $finalPriceEle.attr('data-estimated-price');
      }
    }
    return undefined;
  }
}

theme.AssetsLoader.onPageLoaded(function () {
    new CashBackGuide();
});
})(jQueryTheme);